import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TExtractedIDDocumentDetails } from "./uploadI9OnboardingIDDocumentSchema";

export const uploadI9OnboardingIDDocument = (axios: IAxiosInstance) => {
  return async (data: FormData) => {
    const response = await axios.noRetry.patch<
      ZealApiResponse<TExtractedIDDocumentDetails>
    >(`/api/uploadI9OnboardingIDDocument`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
